export default __webpack_public_path__ + "static/media/departmentsOrange.892db582.svg";